module.exports = __webpack_public_path__ + "img/history-icon.1de37013.svg";